import { client } from './client';
import interceptors from './interceptors';
import qs from 'qs';

client.interceptors.request.use(interceptors.auth, interceptors.onError);

function getDataCourier(params) {
	return client.get('tunnel/api/stockist/profile/datacourier', {
		params: params
	});
}

function updateCourier(params) {
	return client.post('tunnel/api/stockist/profile/updatecourier', qs.stringify(params), {
		header: {
			'Content-Type': 'application/x-www-form-urlencoded',
		},
	});
}


export default {
	getDataCourier,
	updateCourier
}